import styled from 'styled-components';

export const Arrow = styled.button`
	appearance: none;
	user-select: none;
	outline: none !important;
	display: inline-block;
	position: relative;
	cursor: pointer;
	padding: 0;
	border: none;
	border-top: 16px solid transparent;
	border-bottom: 16px solid transparent;
	transition: all .25s ease-out;
`;

export const ArrowLeft = styled(Arrow)`
	border-right: 24px solid #009966;
	left: 15px;
	:hover {
		border-right-color: #009944;
	}
`;

export const ArrowRight = styled(Arrow)`
	border-left: 24px solid #009966;
	right: 15px;
	:hover {
		border-left-color: #009944;
	}
`;

export const CalendarContainer = styled.div`
	font-size: 12px;
	border: 0px solid #06c;
	border-radius: 5px;
	overflow: hidden;
`;

export const CalendarHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template: repeat(7, auto) / repeat(7, auto);
`;

export const CalendarMonth = styled.div`
	font-weight: 500;
	font-size: 14px;
	color: #009944;
	text-align: center;
	padding: 5px 3px;
	word-spacing: 5px;
	user-select: none;
`;

export const CalendarCell = styled.div`
	text-align: center;
	align-self: center;
	letter-spacing: 0.1rem;
	padding: 3px;
	user-select: none;
  grid-column: ${props => (props.index % 7) + 1} / span 1;
`;

export const CalendarDay = styled(CalendarCell)`
	font-weight: 300;
	font-size: 13px;
	color: #ffffff;
	border-top: 1px solid #009944;
	border-bottom: 1px solid #009944;
	background-color:#009944;
	border-right: ${props => (props.index % 7) + 1 === 7 ? `none` : `1px solid #009999`};
`;

export const CalendarDate = styled(CalendarCell)`
	font-weight: ${props => props.inMonth ? 500 : 300};
	font-size: 14px;
	cursor: pointer;
	border-bottom: ${props => ((props.index + 1) / 7) <= 5 ? `1px solid #ddd` : `none`};
	border-right: ${props => (props.index % 7) + 1 === 7 ? `none` : `1px solid #ddd`};
	color: ${props => props.inMonth ? `#333` : `#ddd`};
  	grid-row: ${props => Math.floor(props.index / 7) + 2} / span 1;
	transition: all .4s ease-out;
	:hover {
		color: #009944;
		background: rgba(0, 148, 68, 0.075);
	}
`;

export const HighlightedCalendarDate = styled(CalendarDate)`
	color: #fff !important;
	background: #009933 !important;
	position: relative;
	::before {
		box-sizing:border-box;
		content: '';
		position: absolute;
		top: -1px;
		left: -1px;
		width: calc(100% + 2px);
		height: calc(100% + 2px);
		border: 2px solid #009944;
	}
`;

export const TodayCalendarDate = styled(HighlightedCalendarDate)`
	color: #009944 !important;
	background: transparent !important;
	::after {
		content: '';
		position: absolute;
		right: 0;
		bottom: 0;
		border-bottom: 0.75em solid #009944;
		border-left: 0.75em solid transparent;
		border-top: 0.75em solid transparent;
	}
	:hover {
		color: #06c !important;
		background: rgba(0, 148, 68, 0.075) !important;
	}
`;
